const brands = [
  { brand: "KLS", _id: 1 },
  { brand: "SF", _id: 2 },
  { brand: "PDC", _id: 3 },
  { brand: "PIS", _id: 4 },
  { brand: "SPR", _id: 5 },
  { brand: "PRR", _id: 6 },
  { brand: "QPR", _id: 7 },
  { brand: "PF", _id: 8 }
];
export default brands;
